import config from './config';
import encodeHTMLEntities from './utils/encodeHTMLEntities';
var State = /*@__PURE__*/ (function () {
    function State() {
        var _this = this;
        this.getState = function () {
            return _this.state;
        };
        this.syncLocalStorage = function () {
        };
        this.setState = function (newState) {
            for (var prop in newState) {
                _this.state[prop] = _this.checkUserInput(prop, newState[prop]);
            }
            _this.dispatchState();
        };
        this.checkUserInput = function (prop, input) {
            if (prop === 'firstname' || prop === 'lastname' || prop === 'text') {
                input = encodeHTMLEntities(input);
            }
            return input;
        };
        this.dispatchState = function () {
            window.vf._memory = window.vf._memory || {};
            window.vf._memory.appointmanFlowWatchers = window.vf._memory.appointmanFlowWatchers || [];
            for (var _i = 0, _a = window.vf._memory.appointmanFlowWatchers; _i < _a.length; _i++) {
                var watcher = _a[_i];
                watcher();
            }
        };
        this.state = {
            CURRENT_FLOW: config.appointman.flow.CHOOSE_TYPE,
            shopInfo: {},
            distance: false,
            rmsID: false,
            email: '',
            phone: '',
            apmTopic: '',
            firstname: '',
            lastname: '',
            customernumber: '',
            text: '',
            date: new Date(),
            timeslot: '',
            apmType: '',
            APPOINTMAN_TYPES: {},
        };
    }
    return State;
}());
export default State;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/State.ts
// module id = null
// module chunks = 